module.exports = __webpack_public_path__ + "static/img/m3.790847f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newWebSiteImg/pc/cooperation/m3.png
// module id = MeoH
// module chunks = 3